export class FilterUrlBuilder {
  static BASE_PATH = '/location_management/parking_sessions/filter'

  static build (locationId, params) {
    const baseUrl = `${this.BASE_PATH}/${locationId}`
    const searchParams = new URLSearchParams({
      session_type: params.sessionType || '',
      tab_type: params.tabType || ''
    })

    if (params.query) {
      searchParams.append('query', params.query)
    }

    if (params.dateRange) {
      searchParams.append('date_range', params.dateRange)
    }

    if (params.fromTime) {
      searchParams.append('from_time', params.fromTime)
    }

    if (params.toTime) {
      searchParams.append('to_time', params.toTime)
    }

    if (params.perPage) {
      searchParams.append('per_page', params.perPage)
    }

    return `${baseUrl}?${searchParams.toString()}`
  }

  static parseParams (url) {
    try {
      const urlObj = new URL(url, window.location.origin)
      return urlObj.searchParams
    } catch (e) {
      return null
    }
  }
}
